import React, { createContext, useContext, useState, ReactNode } from 'react';

interface AuthorizationContextType {
    isAuthorized: boolean;
    setIsAuthorized: (value: boolean) => void;
}

const AuthorizationContext = createContext<AuthorizationContextType | undefined>(undefined);

export const AuthorizationProvider = ({ children }: { children: ReactNode }) => {
    const [isAuthorized, setIsAuthorized] = useState(true);

    return (
        <AuthorizationContext.Provider value={{ isAuthorized, setIsAuthorized }}>
            {children}
        </AuthorizationContext.Provider>
    );
};

export const useAuthorization = () => {
    const context = useContext(AuthorizationContext);
    if (!context) {
        throw new Error('useAuthorization must be used within AuthorizationProvider');
    }
    return context;
};
